// export function camel (str) {
//   const camel = (str || '').replace(/-([^-])/g, g => g[1].toUpperCase());

//   return capitalize(camel);
// }

// export function camelActual (str) {
//   return (str || '').replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : ''));
// }

// export function kebab (str) {
//   return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
// }

// export function capitalize (str) {
//   str = str || '';

//   return `${str.substr(0, 1).toUpperCase()}${str.slice(1)}`;
// }

// export function findProduct (store, id) {
//   return store.state.store.products.find(p => p.id === id);
// }

// export function isOnSale (variants) {
//   return variants.some(variant => {
//     return parseFloat(variant.price) < parseFloat(variant.compareAtPrice);
//   });
// }

// export function randomNumber (min, max) {
//   return Math.floor(Math.random() * max) + min;
// }

// export function randomString (length = 5) {
//   let text = '';
//   const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

//   for (let i = 0; i < length; i++) {
//     text += possible.charAt(Math.floor(Math.random() * possible.length));
//   }

//   return text;
// }
const randomElement = (arr = []) => {
  return arr[Math.floor(Math.random() * arr.length)];
};

const kebab = str => {
  return (str || "").replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
};

const toggleFullScreen = () => {
  let doc = window.document;
  let docEl = doc.documentElement;

  let requestFullScreen =
    docEl.requestFullscreen ||
    docEl.mozRequestFullScreen ||
    docEl.webkitRequestFullScreen ||
    docEl.msRequestFullscreen;
  let cancelFullScreen =
    doc.exitFullscreen ||
    doc.mozCancelFullScreen ||
    doc.webkitExitFullscreen ||
    doc.msExitFullscreen;

  if (
    !doc.fullscreenElement &&
    !doc.mozFullScreenElement &&
    !doc.webkitFullscreenElement &&
    !doc.msFullscreenElement
  ) {
    requestFullScreen.call(docEl);
  } else {
    cancelFullScreen.call(doc);
  }
};

const changed = (new_a, old_a, names) => {
  let retval = false;
  names.forEach(itm => {
    if (new_a && old_a && new_a[itm] !== old_a[itm]) {
      retval = true;
    }
  });
  return retval;
};
const forms = (function() {
  function asyncCaller(clbck) {
    var res = true;
    var c = 0;
    var m = 0;
    var end = false;
    function complete(ok) {
      if (!ok) {
        res = false;
      }
      m++;
      if (end && m === c) {
        if (clbck) clbck(res);
      }
    }
    function endCall() {
      end = true;
      if (c === m) {
        if (clbck) clbck(res);
      }
    }

    function next() {
      c++;
      return complete;
    }
    return {
      end: endCall,
      next: next
    };
  }

  function chain() {
    var _chain = [];
    function add(fnDesc) {
      _chain.push(fnDesc);
    }
    function run(str, clbck) {
      var output = str;
      var errors = [];
      var c = 0;
      function runFn(i) {
        var desc = _chain[i];
        if (desc) {
          desc.fn(next, output, desc.arg);
        } else {
          stop();
        }
      }
      function stop() {
        clbck(output, errors);
      }
      function next(fn) {
        if (c < _chain.length) {
          try {
            output = fn();
          } catch (e) {
            if (e.continueFlag) {
              stop();
            } else {
              errors.push(e);
            }
          }
          c++;
          runFn(c);
        } else {
          stop();
        }
      }

      if (_chain.length > 0) {
        runFn(0);
      } else {
        stop();
      }
    }
    return {
      add: add,
      run: run
    };
  }

  function validator_exception(name, continueFlag) {
    return {
      name: name,
      continueFlag: continueFlag
    };
  }

  function message_translator() {
    var _messages = {};
    function translate() {}
    return {
      translate: translate
    };
  }

  function validator() {
    var _chain = chain();
    function run(str, clbck) {
      return _chain.run(str, clbck);
    }
    var validators = {
      required: function(next, val) {
        next(function() {
          if (!val) {
            throw validator_exception("required");
          }
          return val;
        });
      },
      dummy: function(next, val) {
        next(function() {
          if (val != "dummy") {
            throw validator_exception("dummy");
          }
          return val;
        });
      },
      continueIf: function(next, val, a) {
        setTimeout(function() {
          next(function() {
            if (!a()) {
              throw validator_exception("no_continue", true);
            }
            return val;
          });
        }, 1500);
      }
    };
    function addValidator(n) {
      return function(a) {
        _chain.add({ fn: validators[n], arg: a });
        return _this;
      };
    }
    var _this = {
      run: run
    };
    for (var i in validators) {
      _this[i] = addValidator(i);
    }

    return _this;
  }

  return {
    v: validator,
    exc: validator_exception
  };
})();

const tr = str => {
  return str;
};

const findInArray = (array, predicate) => {
  if (array.find) {
    return array.find(predicate);
  }
  // 1. Let O be ? ToObject(this value).
  if (array == null) {
    throw TypeError('"this" is null or not defined');
  }

  var o = Object(this);

  // 2. Let len be ? ToLength(? Get(O, "length")).
  var len = o.length >>> 0;

  // 3. If IsCallable(predicate) is false, throw a TypeError exception.
  if (typeof predicate !== "function") {
    throw TypeError("predicate must be a function");
  }

  // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
  var thisArg = arguments[1];

  // 5. Let k be 0.
  var k = 0;

  // 6. Repeat, while k < len
  while (k < len) {
    // a. Let Pk be ! ToString(k).
    // b. Let kValue be ? Get(O, Pk).
    // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
    // d. If testResult is true, return kValue.
    var kValue = o[k];
    if (predicate.call(thisArg, kValue, k, o)) {
      return kValue;
    }
    // e. Increase k by 1.
    k++;
  }

  // 7. Return undefined.
  return undefined;
};

export default {
  randomElement,
  toggleFullScreen,
  kebab,
  changed,
  tr: tr,
  forms: forms,
  findInArray
};



// WEBPACK FOOTER //
// ./src/app/util/index.js